module.exports = __webpack_public_path__ + "static/unicorn-757005ad3525d4317c322168273c8f9d.png";